import { createSlice } from '@reduxjs/toolkit';
import { HttpMethod, sendError_notify } from '../../../Asset/httpMethod';
import { startLoader, stopLoader } from '../Utility/loaderSlice';
import { AlertPopup } from "../../../Asset/common";

export const fetchData = (data, RecordPerPage) => async (dispatch) => {
  if (!data) return;

  data.PageNo = [1];
  dispatch(startLoader());

  try {

    // console.log("fetchData called with data:", data);
    const res = await HttpMethod.post('/Stock/StockSearch/AsyncStockList', data);


    if (res?.status === 200) {
      dispatch(resetCombinedData());
      dispatch(setFirstData(res?.data));

      const stockList = res?.data?.StockPacketList1 || [];
      const pcs = stockList[0]?.I_PCS;

      if (pcs) {
        const pages = Math.ceil(pcs / RecordPerPage);
        Array.from({ length: pages - 1 }, (_, index) => {
          dispatch(fetchNextData({ ...data, PageNo: [index + 2] }));
        });
      }

    }

  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    if (data?.PageNo[0] === 1) {
      dispatch(stopLoader());
    }
  }
};


export const fetchDataForPagination = (data, RecordPerPage, PageNo = 1) => async (dispatch) => {
  if (!data) return;

  // Set the requested page number in the payload
  if (!data.hasOwnProperty('PageNo')) {
    data.PageNo = [];
    
  }

  data.PageNo = [PageNo];


  // Only show loader on first page load or if you want it on every page
  // if (PageNo === 1) {
    dispatch(startLoader());
  // }

  try {
    const res = await HttpMethod.post('/Stock/StockSearch/AsyncStockList', data);

    if (res?.status === 200) {
      // If it's a fresh search (Page 1), reset existing data
      if (PageNo === 1) {
        dispatch(resetCombinedData());
      }

      // Set/Append the data for the requested page
      dispatch(setFirstData(res?.data));

      // IMPORTANT: No loop here. The grid will handle fetching next pages via the API.
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    // Always stop loader after fetch
    dispatch(stopLoader());
  }
};


export const fetchWebStockPartyData = (data) => async (dispatch) => {
  dispatch(startLoader())
  const ObjJson = {
    jsonObj1: [data],
    SPName: "API_PartyStockExcelDisp"
  };
  let res = await HttpMethod.post(`/SystemConfig/InsUpdDel/DynSpExAsyncDisp`, ObjJson)
  dispatch(stopLoader())
  return res?.data?.DynDisp
};

export const fetchNextData = (data) => async (dispatch) => {
  const res = await HttpMethod.post('/Stock/StockSearch/StockList', data);
  if (res?.status === 200) {
    dispatch(appendApiData(await res.data));
  }
};

export const setEmpty = () => async (dispatch) => {
  dispatch(resetCombinedData({}));
}

export const PacketSearchSlice = createSlice({
  name: 'PacketSearch',
  initialState: { StockPacketList: [], StockPacketList1: [] },
  reducers: {
    setFirstData: (state, action) => {
      state.StockPacketList = action.payload.StockPacketList;
      state.StockPacketList1 = action.payload.StockPacketList1;
      return state;
    },
    appendApiData: (state, action) => {

      // state.StockPacketList = [...state.StockPacketList, ...action.payload.StockPacketList]; ///ama problem avti hti data duplicate thata hata atle comment kryu che

      state.StockPacketList = Array.from(
        new Set([...state.StockPacketList, ...action.payload.StockPacketList].map(JSON.stringify))
      ).map(JSON.parse);

      state.StockPacketList1 = action.payload.StockPacketList1;
      return state;
    },
    resetCombinedData: (state) => {
      state.StockPacketList = [];
      return state;
    },
  },
});

export const { setFirstData, appendApiData, resetCombinedData } = PacketSearchSlice.actions;
export default PacketSearchSlice.reducer;